var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cbmarkdown"},[_c('div',{staticClass:"content mb-2",domProps:{"innerHTML":_vm._s(_vm.sanitizedHTML)}})])}
var staticRenderFns = []

export { render, staticRenderFns }